// extracted by mini-css-extract-plugin
export default {"page":"Property_page__NhuUp"};